import { Component, effect, HostListener, OnDestroy, OnInit, untracked } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { SidebarModule } from 'primeng/sidebar';
import { SkeletonModule } from 'primeng/skeleton';
import { ToastModule } from 'primeng/toast';
import { MobileToasterService } from 'projects/shared/components/mobile-toaster/services/mobile-toaster.service';
import { IUser } from 'projects/shared/models/interfaces/user.model';
import { AuthService } from 'projects/shared/services/auth.service';
import { BrowserService } from 'projects/shared/services/browser.service';
import { ExchangeService } from 'projects/shared/services/exchange.service';
import { StoreChangesService } from 'projects/shared/services/store-changes.service';
import { LanguageService } from 'projects/shop/src/app/+shared/services/language.service';
import { CountriesService } from 'projects/shop/src/app/modules/auth/services/countries.service';
import { filter, noop, Subscription, tap } from 'rxjs';
import { countriesService } from 'projects/shop/src/app/modules/home/services/countries.service';
import { DropdownComponent } from 'projects/shop/src/app/modules/user-settings/components/dropdown/dropdown.component';
import { Store } from '@ngrx/store';
import { RegionalActions } from './store/regional-setting.actions';
import { SelectRegionalSettings } from './store/regional-setting.selectors';
import { ModalComponent } from 'projects/shared/components/modal/modal.component';
import { selectTheme } from '../../store/navbar.selectors';

@Component({
  selector: 'app-nav-regional',
  standalone: true,
  imports: [FormsModule, DialogModule, DropdownModule, ReactiveFormsModule, SidebarModule, SkeletonModule, ToastModule, DropdownComponent, ModalComponent],
  providers: [MessageService],
  templateUrl: './nav-regional.component.html',
  styleUrl: './nav-regional.component.scss'
})
export class NavRegionalComponent implements OnInit, OnDestroy {

  countryFlag = '';

  //! Language Variables
  arabicLang = false;
  lang = '';

  // ! Exchange Variables
  exchange!: any;
  exchangeRates!: any;

  // ! Currency
  currencyList = [
    {
      currency: 'USD',
      icon: '../../../../../assets/images/wallet/USD.png',
    },
    {
      currency: 'EGP',
      icon: '../../../../../assets/images/wallet/EGP.png',
    },
    {
      currency: 'EUR',
      icon: '../../../../../assets/images/wallet/EUR.png',
    },
    {
      currency: 'SAR',
      icon: '../../../../../assets/images/wallet/SAR.png',
    },
    {
      currency: 'AED',
      icon: '../../../../../assets/images/wallet/AED.png',
    },
    {
      currency: 'INR',
      icon: '../../../../../assets/images/wallet/INR.png',
    },
    {
      currency: 'BHD',
      icon: '../../../../../assets/images/wallet/BHD.png',
    },
    {
      currency: 'KWD',
      icon: '../../../../../assets/images/wallet/KWD.png',
    },
    {
      currency: 'QAR',
      icon: '../../../../../assets/images/wallet/QAR.png',
    },
    {
      currency: 'ZAR',
      icon: '../../../../../assets/images/wallet/ZAR.png',
    },
    {
      currency: 'TRY',
      icon: '../../../../../assets/images/wallet/TRY.png',
    },
    {
      currency: 'RUB',
      icon: '../../../../../assets/images/wallet/RUB.png',
    },
  ];

  // ! Currency
  currencyListEntity: Record<string, { currency: string; icon: string }> = {
    USD: { currency: 'USD', icon: '../../../../../assets/images/wallet/USD.png' },
    EGP: { currency: 'EGP', icon: '../../../../../assets/images/wallet/EGP.png' },
    EUR: { currency: 'EUR', icon: '../../../../../assets/images/wallet/EUR.png' },
    SAR: { currency: 'SAR', icon: '../../../../../assets/images/wallet/SAR.png' },
    AED: { currency: 'AED', icon: '../../../../../assets/images/wallet/AED.png' },
    INR: { currency: 'INR', icon: '../../../../../assets/images/wallet/INR.png' },
    BHD: { currency: 'BHD', icon: '../../../../../assets/images/wallet/BHD.png' },
    KWD: { currency: 'KWD', icon: '../../../../../assets/images/wallet/KWD.png' },
    QAR: { currency: 'QAR', icon: '../../../../../assets/images/wallet/QAR.png' },
    ZAR: { currency: 'ZAR', icon: '../../../../../assets/images/wallet/ZAR.png' },
    TRY: { currency: 'TRY', icon: '../../../../../assets/images/wallet/TRY.png' },
    RUB: { currency: 'RUB', icon: '../../../../../assets/images/wallet/RUB.png' },
  };
  // ! Website Language
  languages = [
    { label: 'English', code: 'en' },
    { label: 'عربي', code: 'ar' }
  ];

  // ! Website Language
  languagesEntity: Record<string, { label: string; code: string }> = {
    en: { label: 'English', code: 'en' },
    ar: { label: 'عربي', code: 'ar' },
  };

  // ! Countries Vars
  countries: any;
  countryName: any;

  // ! Regional Settings variables
  selectedRegion: any;
  selectedCur = '';
  regionForm!: FormGroup;

  // ! Modal Visibility Variable
  currencyDialog = false;
  currencyBar = false;

  // ! Selected Data
  selectedCountry!: any;
  selectedLang!: any;
  selectedCurrency!: any;
  activeCurrency!: string;

  // ! For Loader
  isLoading = false;
  updatingSettings = false;

  // ! Subscription For APIs
  private _subscription = new Subscription();

  // ! Mobile Detection
  mobileScreen = false;

  // ! user data
  user!: IUser;


  userRegion: any;

  regionalSettings$!: any;

  theme$: any = this._store.selectSignal(selectTheme)

  constructor(
    private _formBuilder: FormBuilder,
    private _authService: AuthService,
    private _storeChangesService: StoreChangesService,
    private _countriesService: CountriesService,
    private _exchangeService: ExchangeService,
    private _languageService: LanguageService,
    private _browserService: BrowserService,
    private _mobileToasterService: MobileToasterService,
    private _messageService: MessageService,
    private _translateService: TranslateService,
    private _countryCodesService: countriesService,
    private _store: Store
  ) {
    this.regionalSettings$ = _store.selectSignal(SelectRegionalSettings);
    effect(() => {
      const settings = this.regionalSettings$(); // الاعتماد الوحيد اللي عايزه
      this.getExchangeRates()
      untracked(() => this.initRegionalSettings());
    }, { allowSignalWrites: true })
  }

  ngOnInit(): void {
    this._store.dispatch(RegionalActions.initialize());
    this.initRegionForm();
    this.detectUser();
    this.detectScreenSize();
    if (!this.countries?.length) this.getCountries();
  }

  getExchangeRates() {
    this._subscription.add(
      this._storeChangesService.getExchange().pipe(
        filter(res => !!res),
        tap(
          res => {
            this.exchangeRates = res
            this._storeChangesService.setActivatedCurrency({ key: this.regionalSettings$().currency, value: this.exchangeRates[this.regionalSettings$().currency] })
          }
        )
      ).subscribe(noop)
    )
  }

  // ! check if user logged in or not
  detectUser() {
    this._storeChangesService.getUser().pipe(
      tap(
        res => {
          this.user = res;
        }
      )
    ).subscribe(noop)
  }

  // ! Detect Mobile Screen 
  detectScreenSize() {
    if (this._browserService.getWindow()) {
      if (window.innerWidth < 769) {
        this.mobileScreen = true;
      } else {
        this.mobileScreen = false;
      }
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (this._browserService.getWindow()) {
      if (window.innerWidth < 769) {
        this.mobileScreen = true;
      } else {
        this.mobileScreen = false;
      }
    }
  }

  initRegionForm() {
    this.regionForm = this._formBuilder.group({
      country: ['Egypt'],
      countryCode: ['EG'],
      language: ['ar'],
      currency: ['USD']
    });
  }

  // ! Region Form Controls
  get regionalCountry(): AbstractControl { return this.regionForm.get('country')! };
  get regionalCountryCode(): AbstractControl { return this.regionForm.get('countryCode')! };
  get regionalLang(): AbstractControl { return this.regionForm.get('language')! };
  get regionalCurrency(): AbstractControl { return this.regionForm.get('currency')! };

  onCountrySelect(country: any) {
    if (!country) return;
    const countryName = typeof country === 'string' ? country : country.name;
    const countryCode = country.code || this.getCountryCode(countryName);
    this.selectedCountry = { name: countryName, code: countryCode };
    this.regionForm.patchValue({
      country: countryName,
      countryCode: countryCode
    }, { emitEvent: false });
  }

  onLanguageSelect(lang: any) {
    if (!lang) return;
    const code = typeof lang === 'string' ? lang : (lang.code || lang.name);
    this.selectedLang = this.languagesEntity[code] || lang;
    this.regionForm.patchValue({
      language: code
    }, { emitEvent: false });
  }

  onCurrencySelect(cur: any) {
    if (!cur) return;
    const currencyStr = typeof cur === 'string' ? cur : cur.currency;
    this.selectedCurrency = this.currencyListEntity[currencyStr] || cur;
    this.activeCurrency = currencyStr;
    this.regionForm.patchValue({
      currency: currencyStr
    }, { emitEvent: false });
  }

  initRegionalSettings() {
    const settings = this.regionalSettings$();
    const countryName = settings?.country || 'Egypt';
    const countryCode = this.getCountryCode(countryName) || 'EG';
    const currency = settings?.currency || 'USD';
    const language = settings?.language || 'ar';

    this.selectedCountry = { name: countryName, code: countryCode };
    this.countryFlag = countryCode;

    this.selectedCurrency = this.currencyListEntity[currency] || { currency, icon: '' };
    this.activeCurrency = this.selectedCurrency.currency;

    this.selectedLang = this.languagesEntity[language] || { label: language, code: language };

    if (this.regionForm) {
      this.regionForm.patchValue({
        country: countryName,
        countryCode: countryCode,
        language: language,
        currency: currency
      });
    }
  }

  getCountries() {
    this._subscription.add(
      this._countriesService.getCountries().pipe(
        tap(
          res => {
            this.countries = res.data;
            const currentCountryName = this.regionForm?.get('country')?.value || this.regionalSettings$()?.country || 'Egypt';
            const matched = this.countries?.find((c: any) => c.name?.toLowerCase() === currentCountryName?.toLowerCase());
            if (matched) {
              this.onCountrySelect(matched);
            }
          }
        )
      ).subscribe(noop, err => console.log(err))
    )
  }

  toSnakeCase(str: string): string {
    return str ? str.toLowerCase().trim().replace(/\s+/g, '_') : '';
  }

  getCountryCode(country: string): string {
    if (!country) return '';
    const countryKey = this.toSnakeCase(country);
    return this._countryCodesService?.countryCodes[countryKey] || '';
  }

  createBodyForUpdateSuggestedRegionalSetting() {
    const formVal = this.regionForm.value;
    const countryName = typeof formVal.country === 'string' ? formVal.country : (formVal.country?.name || this.selectedCountry?.name);
    const countryCode = formVal.countryCode || formVal.country?.code || this.getCountryCode(countryName);
    const language = formVal.language || this.selectedLang?.code;
    const currency = formVal.currency || this.activeCurrency;

    return {
      language: language,
      currency: currency,
      country: countryName,
      countryCode: countryCode
    };
  }

  updateRegionalSettings() {
    this.updatingSettings = true;
    const body = this.createBodyForUpdateSuggestedRegionalSetting();

    const cur = body.currency;
    this.selectedCurrency = this.currencyListEntity[cur] || { currency: cur, icon: '' };
    this.activeCurrency = cur;

    if (this.exchangeRates && this.exchangeRates[cur]) {
      this._storeChangesService.setActivatedCurrency({
        key: cur,
        value: this.exchangeRates[cur]
      });
    }

    this.selectedLang = this.languagesEntity[body.language] || { label: body.language, code: body.language };
    this._translateService.use(body.language);
    this._languageService.arabic.next(body.language !== 'en');

    this.selectedCountry = { name: body.country, code: body.countryCode };
    this.countryFlag = body.countryCode;
    this._languageService.selectedCountry.next(body.country);

    this._store.dispatch(RegionalActions.updateData({
      country: body.country,
      currency: body.currency,
      language: body.language
    }));

    this.currencyDialog = false;
    this.saveInLocalStorage(body);

    if (this.user) {
      this._subscription.add(
        this._authService.updateSuggestLanguageAndCurrency(body).pipe(
          tap(
            res => {
              this.countryFlag = body.countryCode;
              this.updatingSettings = false;
              this.currencyBar = false;
              if (this.mobileScreen) this._mobileToasterService.MobileToaster$.next({ severity: 'success', summary: 'Success', detail: res.message });
              else this._messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
            }
          )
        ).subscribe(noop, err => console.log(err))
      );
    } else {
      if (this.mobileScreen) this._mobileToasterService.MobileToaster$.next({ severity: 'success', summary: 'Success', detail: 'Updated Preferences Successfully' });
      else this._messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Preferences Successfully' });
      this.updatingSettings = false;
      this.currencyDialog = false;
      this.currencyBar = false;
    }
  }

  saveInLocalStorage(body: any) {
    let data = {
      country: body.country,
      currency: body.currency,
      lang: body.language,
      countryCode: body.countryCode
    };
    if (this._browserService.getLocalStorage()) {
      localStorage.setItem('UserRegion', JSON.stringify(data));
      if (this.exchangeRates && this.exchangeRates[body.currency]) {
        localStorage.setItem('ActivatedCurrency', JSON.stringify({ currency: body.currency, value: this.exchangeRates[body.currency] }));
      }
    }
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe()
  }
}
